import {
  DATA_SOURCE_ICONS,
  DATA_SOURCE_IDS,
  DATA_SOURCE_LABELS,
} from '@discover-frontend/constants';

import { findGroupLevel } from 'src/utils/misc';

export const QUERY_BUILDER_TYPES = {
  CONVERSATION: 'conversation',
  DEFAULT: 'default',
} as const;

export const ALL_QUERY_BUILDER_TAB_COLORS = [
  { key: '#007ADD', label: 'Blue' },
  { key: '#D6519E', label: 'Pink' },
  { key: '#269F49', label: 'Green' },
  { key: '#DD2A41', label: 'Red' },
  { key: '#FAB239', label: 'Yellow' },
  { key: '#843CAD', label: 'Violet' },
  { key: '#CA4B21', label: 'Orange' },
];

export const DEFAULT_QUERY_BUILDER_TAB_COLORS = [
  { key: '#007ADD', label: 'Blue' },
  { key: '#843CAD', label: 'Violet' },
  { key: '#269F49', label: 'Green' },
];

export const QueryBuilderConstants = {
  groupOperatorColors: [
    ['#007ADD', 'rgba(0,122,221,0.3)'],
    ['#D6519E', 'rgba(214,81,158,0.3)'],
    ['#269F49', 'rgba(38,159,73,0.3)'],
    ['#DD2A41', 'rgba(221,42,75,0.3)'],
    ['#FAB239', 'rgba(250,178,57,0.3)'],
    ['#843CAD', 'rgba(132,60,173,0.3)'],
    ['#CA4B21', 'rgba(202,75,33,0.3)'],
  ],
  dataSources: [
    {
      id: DATA_SOURCE_IDS.TWITTER,
      label: DATA_SOURCE_LABELS.TWITTER,
      value: DATA_SOURCE_IDS.TWITTER,
      icon: DATA_SOURCE_ICONS.TWITTER,
      isActive: false,
      disabled: false,
      description:
        'Observed social behavior from a representative sample, reflective of the general populations interests from brands to influencers.',
    },
    {
      id: DATA_SOURCE_IDS.APPS,
      label: DATA_SOURCE_LABELS.APPS,
      value: DATA_SOURCE_IDS.APPS,
      icon: DATA_SOURCE_ICONS.APPS,
      isActive: false,
      disabled: false,
      description:
        'App Usage data from a representative sample, reflective of Americans daily lives from banking to entertainment.',
    },
    {
      id: DATA_SOURCE_IDS.BROWSER,
      label: DATA_SOURCE_LABELS.BROWSER,
      value: DATA_SOURCE_IDS.BROWSER,
      icon: DATA_SOURCE_ICONS.BROWSER,
      isActive: false,
      disabled: true,
      description:
        'Harmonizing web browsing data to uncover insights into user context, interests, content consumption patterns, preferences, and geographical distribution',
    },
    {
      id: DATA_SOURCE_IDS.INSTAGRAM,
      label: DATA_SOURCE_LABELS.INSTAGRAM,
      value: DATA_SOURCE_IDS.INSTAGRAM,
      icon: DATA_SOURCE_ICONS.INSTAGRAM,
      isActive: false,
      disabled: false,
      description: 'Coming soon',
    },
    {
      id: DATA_SOURCE_IDS.INSTAGRAM_FOLLOWS,
      label: DATA_SOURCE_LABELS.INSTAGRAM_FOLLOWS,
      value: DATA_SOURCE_IDS.INSTAGRAM_FOLLOWS,
      icon: DATA_SOURCE_ICONS.INSTAGRAM_FOLLOWS,
      isActive: false,
      disabled: false,
      description: 'Coming soon',
    },
    {
      id: 'purchase',
      label: 'Purchase behaviour',
      value: 'purchase',
      icon: 'consumption',
      isActive: false,
      disabled: true,
      description: 'Coming soon',
    },
  ],
};

/** Solid operator color for a 0-based nesting level (same palette as query preview). */
export const getQueryPreviewPaletteColorForLevel = (level: number): string =>
  level < 0
    ? '#000'
    : QueryBuilderConstants.groupOperatorColors[level % 7][0];

/** Same group colors as vertical/horizontal query preview (`findGroupLevel` + palette). */
export const getQueryPreviewGroupColor = (
  completeQuery: unknown,
  groupId: unknown
): string => {
  const level = findGroupLevel(completeQuery, groupId, 0);
  return getQueryPreviewPaletteColorForLevel(level);
};
